import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

const customStorage = {
  getItem: (key: string) => {
    try {
      const item = window.localStorage.getItem(key);
      console.log('[Storage] Getting key:', key, item ? 'Found' : 'Not found');
      return item;
    } catch (error) {
      console.error('[Storage] Error getting item:', error);
      return null;
    }
  },
  setItem: (key: string, value: string) => {
    try {
      console.log('[Storage] Setting key:', key);
      window.localStorage.setItem(key, value);
    } catch (error) {
      console.error('[Storage] Error setting item:', error);
    }
  },
  removeItem: (key: string) => {
    try {
      console.log('[Storage] Removing key:', key);
      window.localStorage.removeItem(key);
    } catch (error) {
      console.error('[Storage] Error removing item:', error);
    }
  },
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: customStorage,
    flowType: 'pkce',
    debug: true,
    storageKey: 'supabase-auth-token',
  },
});
